var map = {
	".": "yjnE",
	"./": "yjnE",
	"./01_create_api": "uqo+",
	"./01_create_api.json": "uqo+",
	"./02_permission_set": "U3vK",
	"./02_permission_set.json": "U3vK",
	"./03_request_content": "HVe5",
	"./03_request_content.json": "HVe5",
	"./04_sign_discription": "huDF",
	"./04_sign_discription.json": "huDF",
	"./05_request": "2oJ6",
	"./05_request.json": "2oJ6",
	"./index": "yjnE",
	"./index.js": "yjnE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xp0F";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/authentication ^.*$
// module id = xp0F
// module chunks = 3